import type { SliderModal } from '@cian/frontend-newbuilding-promo-modal-widget';
import loadable from '@loadable/component';
import type * as React from 'react';

export type TSliderModalProps = React.ComponentProps<typeof SliderModal>;

/* istanbul ignore next */
export const SliderModalLoadable = loadable(() => import('@cian/frontend-newbuilding-promo-modal-widget'), {
  resolveComponent: ({ SliderModal }) => SliderModal,
  ssr: false,
});
